import { State } from '@hookstate/core';

import { GameState } from '../stores/backend';

export const useTicketPrice = (game: State<GameState>) =>
    game.game_strip_only.value
        ? game.game_strip_cost.value
        : game.game_ticket_cost.value;
